import { useQueries, useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";

import { MapStyle } from "@/lib/rana-map/hooks/use-rana-map";

// Single

export const getPublicationFileVectorStyleQuery = (
  fileDescriptorId: string | undefined,
  styleId: string | null | undefined
) => {
  return getRanaApiV1().getQueryOptions<MapStyle | undefined>({
    queryKey: ["file-vector-style", fileDescriptorId, styleId],
    enabled: !!fileDescriptorId || !!styleId,
    retryOnMount: false,
    queryFn: async () => {
      // If a style id was given, use that to fetch the style. It is a style configured
      // from the Rana desktop client.
      try {
        let json;
        if (styleId) {
          json = await getRanaApiV1().StylesApi.getStyle({
            styleId,
            fileName: "style.json",
          });
        } else {
          if (!fileDescriptorId) {
            throw new Error(
              "No file descriptor id or style id provided (this should never happen)"
            );
          }
          json = await getRanaApiV1().StylesApi.getFileDescriptorStyle({
            fileDescriptorId,
            fileName: "style.json",
          });
        }

        // The file in AWS should be saved as a JSON file,
        // but there used to be a bug where it did not get a content type and got served as text,
        // In that case throw an error, converting it to JSON does not help because maplibre itself also does this fetch but that needs a JSON repsonse
        if (typeof json === "string") {
          throw new Error("Received style as string, expected JSON object");
        } else {
          return json as MapStyle;
        }
      } catch (e) {
        // If the style is not found, it will throw a 404 error. In that case, we can just return undefined and the map will be styled with the default style.
        if (e instanceof Response && e.status === 404) {
          console.log(
            "Ignore above error, giving a 404 error is expected when a style is not found"
          );
          return undefined;
        }
        throw e;
      }
    },
  });
};

export const useFileVectorStyleQueryV1 = (descriptorId: string | undefined) => {
  return useQuery(getPublicationFileVectorStyleQuery(descriptorId, null));
};

export const useFileVectorStylesQueryV1 = (descriptorIds: string[]) => {
  return useQueries({
    queries: descriptorIds.map((id) => getPublicationFileVectorStyleQuery(id, null)),
  });
};

export const useVectoryStyleQuery = (styleId: string | undefined) => {
  return useQuery(getPublicationFileVectorStyleQuery(undefined, styleId));
};
